import React, { useState } from 'react';
import './Tabs.css';
// import EventTab from './EventTab';
import PersonTab from './PersonTab';
import VehicleTab from './VehicleTab';
import StoryboardOverview from './StoryboardOverview';

// 添加 trackedObjects 参数和 onEventSelect 参数
const Tabs = ({ 
  trackedObjects = { person: [], vehicle: [], debrief: [] },
  onEventSelect 
}) => {
  // 更新标签配置，添加 Debrief 标签
  const tabs = [
    // { id: 'event', label: 'Event' }
    { id: 'debrief', label: 'Situationnal Overview' } ,
    { id: 'person', label: 'Person' },
    { id: 'vehicle', label: 'Vehicle' },
    // { id: 'debrief', label: 'Debrief' } // 新增的故事板简报标签
  ];

  // 当前激活的标签
  const [activeTab, setActiveTab] = useState('debrief');

  // 处理标签切换
  const handleTabChange = (tabId) => {
    setActiveTab(tabId);
  };

  // 更新渲染逻辑，只传递 StoryboardOverview 需要的参数
  const renderTabContent = () => {
    switch (activeTab) {
      // case 'event':
      //   return <EventTab trackedObjects={trackedObjects.event} />;
      case 'debrief':
        // 只传递 onEventSelect 参数，不传递 trackedObjects
        return <StoryboardOverview onEventSelect={onEventSelect} />;
      case 'person':
        return <PersonTab trackedObjects={trackedObjects.person} />;
      case 'vehicle':
        return <VehicleTab trackedObjects={trackedObjects.vehicle} />;

      default:
        return <div>未知标签</div>;
    }
  };

  return (
    <div className="tabs-container">
      {/* 标签导航 */}
      <div className="tabs-nav">
        {tabs.map(tab => (
          <button
            key={tab.id}
            className={`tab-button ${activeTab === tab.id ? 'active' : ''} ${tab.id === 'debrief' ? 'debrief-tab' : ''}`}
            onClick={() => handleTabChange(tab.id)}
          >
            {tab.label}
            {/* 添加跟踪对象计数器，排除 debrief 标签 */}
            {tab.id !== 'debrief' && trackedObjects[tab.id]?.length > 0 && (
              <span className="tracked-count">{trackedObjects[tab.id].length}</span>
            )}
          </button>
        ))}
      </div>
      
      {/* 标签内容区域 */}
      <div className={`tab-content ${activeTab === 'debrief' ? 'debrief-content' : ''}`}>
        {renderTabContent()}
      </div>
    </div>
  );
};

export default Tabs;